var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
    "dismiss": `Odstranit`
};


export {$b983974c2ee1efb3$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
